import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import convertModule from "./convertModule.js";
import { getHelperFunctions } from "../helpers/index.js";
import { getViewTplName } from "./getTplName.js";
import { withBox } from "../withBox.js";
export function convertView(_x, _x2) {
  return _convertView.apply(this, arguments);
}
function _convertView() {
  _convertView = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(view, options) {
    var _convertedEntry;
    var entry, convertedEntry, state, functions, templates, helpers, _ref2, title, bricks, context, needBox;
    return _regeneratorRuntime().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          entry = view.entry;
          if (entry) {
            _context2.next = 1;
            break;
          }
          throw new Error("No entry module found in the view.");
        case 1:
          state = {
            usedHelpers: new Set(),
            app: view,
            convertedModules: new Map()
          };
          functions = [];
          templates = [];
          _context2.next = 2;
          return Promise.all(Array.from(view.modules.values()).map(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(mod) {
              var converted, _i, _arr, part, raw, promise, _part, _t;
              return _regeneratorRuntime().wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!mod) {
                      _context.next = 8;
                      break;
                    }
                    _context.next = 1;
                    return convertModule(mod, state, options);
                  case 1:
                    converted = _context.sent;
                    if (mod === entry) {
                      convertedEntry = converted;
                    }
                    _i = 0, _arr = [].concat(_toConsumableArray(converted.internals), _toConsumableArray(converted.namedExports.values()), [converted.defaultExport]);
                  case 2:
                    if (!(_i < _arr.length)) {
                      _context.next = 8;
                      break;
                    }
                    part = _arr[_i];
                    if (part) {
                      _context.next = 3;
                      break;
                    }
                    return _context.abrupt("continue", 7);
                  case 3:
                    raw = part.raw, promise = part.promise;
                    _t = raw === null || raw === void 0 ? void 0 : raw.type;
                    _context.next = _t === "function" ? 4 : _t === "template" ? 5 : 7;
                    break;
                  case 4:
                    functions.push(raw["function"]);
                    return _context.abrupt("continue", 7);
                  case 5:
                    _context.next = 6;
                    return promise;
                  case 6:
                    _part = _context.sent;
                    templates.push({
                      name: getViewTplName(_part.name, options.rootId),
                      bricks: _part.bricks,
                      state: _part.context
                    });
                    return _context.abrupt("continue", 7);
                  case 7:
                    _i++;
                    _context.next = 2;
                    break;
                  case 8:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x3) {
              return _ref.apply(this, arguments);
            };
          }()));
        case 2:
          if ((_convertedEntry = convertedEntry) !== null && _convertedEntry !== void 0 && _convertedEntry.defaultExport) {
            _context2.next = 3;
            break;
          }
          throw new Error("No view found in the entry module.");
        case 3:
          helpers = Array.from(state.usedHelpers).map(function (name) {
            var source = getHelperFunctions().get(name);
            if (!source) {
              throw new Error("Helper function ".concat(name, " not found"));
            }
            return {
              name: name,
              source: source,
              typescript: true
            };
          });
          _context2.next = 4;
          return convertedEntry.defaultExport.promise;
        case 4:
          _ref2 = _context2.sent;
          title = _ref2.title;
          bricks = _ref2.bricks;
          context = _ref2.context;
          needBox = function needBox() {
            return bricks.every(function (brick) {
              return ["eo-form", "eo-descriptions", "eo-button"].includes(brick.brick);
            });
          };
          return _context2.abrupt("return", {
            title: title,
            brick: options.withoutWrapper ? bricks : {
              brick: "eo-content-layout",
              children: needBox() ? [withBox(bricks, options)] : bricks
            },
            context: [].concat(_toConsumableArray(context), _toConsumableArray(options.withContexts ? Object.entries(options.withContexts).map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                name = _ref4[0],
                value = _ref4[1];
              return {
                name: name,
                value: value
              };
            }) : [])),
            functions: [].concat(functions, _toConsumableArray(helpers)),
            templates: templates
          });
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _convertView.apply(this, arguments);
}
//# sourceMappingURL=convertView.js.map